// eslint-disable-next-line import/extensions
import Cookies from 'js-cookie';

function getTokens() {
  return Cookies.get('userTokens');
}
export default getTokens;
